import r from"react";import t from"./assets/invalid.svg.js";import e from"./assets/correct.svg.js";const s=({hasError:s,isCorrect:o})=>s?r.createElement("img",{alt:"Error",src:t}):o?r.createElement("img",{alt:"Correct",src:e}):null;export{s as TextFieldIcon};
//# sourceMappingURL=TextFieldIcon.js.map
